"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedAbortableCall = void 0;
const react_1 = require("react");
const domain_1 = require("@home-health-notify/domain");
const RequestDebounceHelper_1 = require("../utils/RequestDebounceHelper"); // Do not shorten this import as it creates a cyclic dependency
const useDebouncedAbortableCall = (fn, debounceDelay, callbackDeps = []) => {
    const abortContextRef = (0, react_1.useRef)(undefined);
    const isExecuting = (0, react_1.useRef)(false);
    const isPendingOnDebounce = (0, react_1.useRef)(false);
    const debouncedFn = (0, react_1.useCallback)((0, RequestDebounceHelper_1.debounce)((...args) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isExecuting.current = true;
            isPendingOnDebounce.current = false;
            yield fn(abortContextRef.current, ...args);
        }
        finally {
            isExecuting.current = false;
        }
    }), debounceDelay), callbackDeps);
    const execute = (0, react_1.useCallback)((...args) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        abortContextRef.current =
            ((_a = abortContextRef.current) === null || _a === void 0 ? void 0 : _a.renew()) || new domain_1.AbortContext();
        if (!isExecuting.current && !isPendingOnDebounce.current) {
            try {
                isExecuting.current = true;
                yield fn(abortContextRef.current, ...args);
            }
            finally {
                isExecuting.current = false;
            }
        }
        else {
            isPendingOnDebounce.current = true;
            yield debouncedFn(...args);
        }
    }), [debouncedFn]);
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = abortContextRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, []);
    return execute;
};
exports.useDebouncedAbortableCall = useDebouncedAbortableCall;
